module.exports = __webpack_public_path__ + "img/logo-transparent.c201d280.png";